<script>
    import {onDestroy, onMount} from 'svelte';

    export let activeTab = 'schedule';

    function setActiveTab(tab) {
        activeTab = tab;
        if (activeTab === 'schedule') {
            if (window.matchMedia("(max-width: 768px)").matches) {
                document.body.style.backgroundImage = "url('./photos/background-main.png')";
                document.body.style.backgroundPosition = "right center";
                document.body.style.backgroundSize = "auto 100%";
                document.body.style.backgroundRepeat = "no-repeat";
            } else {
                document.body.style.backgroundImage = "none";
            }
        } else {
            document.body.style.backgroundImage = "none";
        }
    }


    onMount(() => {
        setActiveTab('schedule');
    });
    onDestroy(() => {
        document.body.style.backgroundImage = "none";
    });

</script>


<div class="menu">
    <div class="flex-row-gap">
        <div class="flex-align-center button" on:click={() => setActiveTab('schedule')}>
            <img class="icon" src="./icons/schedule.png" alt="schedule"/>
        </div>
        <div class="flex-align-center button" on:click={() => setActiveTab('image')}>
            <img class="icon" src="./icons/image.png" alt="schedule"/>
        </div>
        <div class="flex-align-center button" on:click={() => setActiveTab('info')}>
            <img class="icon" src="./icons/info.png" alt="schedule"/>
        </div>
    </div>
</div>

<style>
    .menu-fixed{
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        z-index: 1000;
    }
    @media (max-width: 768px) {
        .menu {
            width: 100%;
            background-color: #ffffff;
            box-shadow: 0px -2px 5px rgba(0, 0, 0, 0.1);
            z-index: 1000;
        }
    }
    .button {
         align-items: center;
         background-color: #FFFFFF;
         border: 1px solid rgba(0, 0, 0, 0.1);
         box-shadow: rgba(0, 0, 0, 0.02) 0 1px 3px 0;
         box-sizing: border-box;
         color: rgba(0, 0, 0, 0.85);
         cursor: pointer;
         display: inline-flex;
         font-family: system-ui,-apple-system,system-ui,"Helvetica Neue",Helvetica,Arial,sans-serif;
         font-size: 16px;
         font-weight: 600;
         justify-content: center;
         line-height: 1.25;
         margin: 0;
         min-height: 3rem;
         padding: calc(.875rem - 1px) calc(1.5rem - 1px);
         position: relative;
         text-decoration: none;
         transition: all 250ms;
         user-select: none;
         -webkit-user-select: none;
         touch-action: manipulation;
         vertical-align: baseline;
         width: 33.3%;
     }
    .button:hover,
    .button:focus {
        border-color: rgba(0, 0, 0, 0.15);
        box-shadow: rgba(0, 0, 0, 0.1) 0 4px 12px;
        color: rgba(0, 0, 0, 0.65);
    }
    .button:hover {
        transform: translateY(-1px);
    }
    .button:active {
        background-color: #F0F0F1;
        border-color: rgba(0, 0, 0, 0.15);
        box-shadow: rgba(0, 0, 0, 0.06) 0 2px 4px;
        color: rgba(0, 0, 0, 0.65);
        transform: translateY(0);
    }
    .flex-row-gap {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .icon{
        width: 25px;
        height: 25px;
    }
    .flex-align-center{
        display: flex;
        flex-direction: row;
        align-items: center;
    }
</style>
